<script lang="ts" setup>
/**
 * Intended to serve as content for UpgradeDialog.vue when hitting the file limit
 */
import { computed } from 'vue'

import { usePlanStore } from './usePlanStore'
import { Resource } from './planTypes'
import { getResourceLimit, getResourceUsage } from './limitAndUsage'
import PlansSelfServeUsageItem from './PlansSelfServeUsageItem.vue'

const planStore = usePlanStore()
const usage = computed(() => {
  const plan = planStore.customerPlan

  const fileLicense = plan?.plan_licenses.find((l) => l.resource === Resource.FILE)
  const userLicense = plan?.plan_licenses.find((l) => l.resource === Resource.USER)
  const workspaceLicense = plan?.plan_licenses.find((l) => l.resource === Resource.WORKSPACE)

  return {
    [Resource.FILE]:
      plan && fileLicense
        ? {
            resourceName: 'Files',
            usage: getResourceUsage(plan, Resource.FILE),
            limit: getResourceLimit(plan, Resource.FILE),
          }
        : null,
    [Resource.USER]:
      plan && userLicense
        ? {
            resourceName: 'Seats',
            usage: getResourceUsage(plan, Resource.USER),
            limit: getResourceLimit(plan, Resource.USER),
          }
        : null,
    [Resource.WORKSPACE]:
      plan && workspaceLicense
        ? {
            resourceName: 'Workspaces',
            usage: getResourceUsage(plan, Resource.WORKSPACE),
            limit: getResourceLimit(plan, Resource.WORKSPACE),
          }
        : null,
  }
})
</script>

<template>
  <div
    v-if="usage.file || usage.user || usage.workspace"
    class="usages"
  >
    <div class="usages__title">Usage</div>
    <div class="usages__list">
      <PlansSelfServeUsageItem
        v-if="usage.file"
        :key="usage.file.resourceName"
        :resource-name="usage.file.resourceName"
        :usage="usage.file.usage"
        :limit="usage.file.limit"
      />

      <PlansSelfServeUsageItem
        v-if="usage.user"
        :key="usage.user.resourceName"
        :resource-name="usage.user.resourceName"
        :usage="usage.user.usage"
        :limit="usage.user.limit"
      />

      <PlansSelfServeUsageItem
        v-if="usage.workspace"
        :key="usage.workspace.resourceName"
        :resource-name="usage.workspace.resourceName"
        :usage="usage.workspace.usage"
        :limit="usage.workspace.limit"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.usages {
  display: flex;
  flex-direction: column;
  padding: var(--size-4);
  padding-top: 0;
  gap: var(--size-4);

  &__title {
    @include textMD13pxBold;
  }

  &__list {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--size-2);
  }
}
</style>
